export default __webpack_public_path__ + "static/media/415.e7c5ca57.png";